import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { Advt } from './components/Advt/Advt';
import { Messages } from './components/Messages/Messages';
import { Winner } from './components/Winner/Winner';

import { useGetParams } from './hooks/useGetParams';
import { useBroadcast } from './hooks/useBroadcast';

import posterDefault from './assets/images/poster.png';
import bgDefaultVideo from './assets/video/bgVideo.mp4';

import bgWinners from './assets/video/bgWinners.mp4';
import posterWinners from './assets/images/posterWinners.png';

import logo from './assets/images/logo.png';
import { motion, AnimatePresence } from 'framer-motion';

function App() {
  const { isVisible, currentState, showedMessages, winnerMesssages, messages } =
    useBroadcast();
  const { speedSlow, bgVideo, bgPoster } = useGetParams();

  return (
    <div
      className="app-wrapper"
      style={{
        '--speed': `${speedSlow || 2000}ms`,
        '--speedExit': `${(speedSlow || 2000) / 1.5}ms`,
      }}>
      <SwitchTransition>
        <CSSTransition
          key={currentState}
          addEndListener={(node, done) =>
            node.addEventListener('transitionend', done, false)
          }
          classNames="fade-scale">
          <div style={{ height: '100%' }}>
            <CSSTransition
              in={isVisible && currentState === 'S1'}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit>
              <div className="advtWrapper">
                <Advt />
              </div>
            </CSSTransition>

            <CSSTransition
              in={isVisible && currentState === 'S1'}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit>
              <Messages messages={showedMessages} speedSlow={speedSlow} />
            </CSSTransition>

            <CSSTransition
              in={isVisible && currentState === 'S2'}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit>
              <Winner winners={winnerMesssages} />
            </CSSTransition>
          </div>
        </CSSTransition>
      </SwitchTransition>

      <AnimatePresence mode="wait">
        {bgVideo && currentState !== 'S2' && (
          <motion.video
            key="bgMain"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.5,
            }}
            autoPlay="autoplay"
            muted="muted"
            loop
            id="bgVideo"
            poster={bgVideo === '1' ? posterDefault : bgPoster}>
            <source
              src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
              type="video/mp4"></source>
          </motion.video>
        )}
      </AnimatePresence>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideoWinners"
        poster={posterWinners}>
        <source src={bgWinners} type="video/mp4"></source>
      </video>

      <img src={logo} alt="logo" className="logo" />

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
